<ng-container *ngIf="isEditing">
    <ng-content select=".input-template"></ng-content>
</ng-container>
<ng-container *ngIf="!isEditing">
    <ng-content select=".output-template"></ng-content>
</ng-container>
